(function ($) {
    function mapFields(form, formFields) {
        $(formFields).each(function (index) {
            var name = $(this).attr('name');
            var value = $(this).val();
            var type = $(this).attr('type');
            let mktoFields = {};
      
            if (form.vals().hasOwnProperty(name)) {
                if (type === "checkbox" || type === "radio") {
                    if ($(this).prop("checked")) {
                        mktoFields[name] = "yes";
                        form.setValues(mktoFields);
                    }
                }
               
                else {
                    mktoFields[name] = value;
                    form.setValues(mktoFields);
                }
            }
        });
    }

    function submitForm(id, fields, sitefinityForm) {
        var currentForm = MktoForms2.getForm(id);
        var button = $(sitefinityForm).find('button');
  
        if (currentForm == null || currentForm == undefined) {
            MktoForms2.loadForm("//info.cornellcookson.com", "256-VME-936", id, function (form) {
                var loadedForm = MktoForms2.getForm(id);
                $(button).click(function () {
                    mapFields(loadedForm, fields);
                    MktoForms2.whenReady(function (form) {
                        if (loadedForm.validate())
                            loadedForm.submit();
                    });
                });
            });
        }
        else {
            $(button).click(function () {
                mapFields(currentForm, fields);
                MktoForms2.whenReady(function (form) {
                    console.log('this is hitting')
                    if (currentForm.validate()) {
                        currentForm.submit();
                    }
                });
            });
        }
        
    }

    $(document).ready(function () {
        var formId = $("input[name=formId]").val();
        var sitefinityForm = $("input[name=formId]").closest('form');
        var formFields = $(sitefinityForm).find('input:visible, textarea, select');
        var multipleForms = $(sitefinityForm).length > 1;
      
        if (formId != null || formId != undefined) {
            if (multipleForms) {
                setTimeout(() => {
                    sitefinityForm = $(".tab-pane.active").find('form');
                    formFields = $(sitefinityForm).find('input:visible, textarea, select');
                    formId = $('.tab-pane.active form input[name=formId]').val();
                    // this needs to be fired on page load to get the first marketo form loaded
                    $('.tab-configurator .nav-tabs a')[0].click();
                }, "1000")

                $('.tab-configurator .nav-tabs a').click(function () {
                    setTimeout(() => {
                        // this is needed to not submit multiple forms to marketo
                        var allForms = $('form');
                        $(allForms).each(function () {
                            $(this).find('button').unbind();
                        }); 
                        sitefinityForm = $(".tab-pane.active").find('form');
                        formFields = $(sitefinityForm).find('input:visible, textarea, select');
                        formId = $('.tab-pane.active form input[name=formId]').val();
                        // you need to remove all the form objects from the dom and via the api so duplicates are not submitted
                        $('form.mktoForm').remove();
                        MktoForms2.allForms().length = 0;
                        submitForm(formId, formFields, sitefinityForm);
                    }, "1000")
                });
            }
            else {
                submitForm(formId, formFields, sitefinityForm);
            }
        }
    });
})(jQuery);